import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { GeneralButtonComponent } from '../../components';
import { IFilterAngularComp } from 'ag-grid-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { he } from 'date-fns/locale';

const DATA_FORMAT = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@Component({
  selector: 'app-ag-custom-date-filter',
  standalone: true,
  imports: [ReactiveFormsModule, MatDatepickerModule, MatInputModule, MatButtonModule, TranslatePipe, GeneralButtonComponent],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: he },
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DATA_FORMAT },
  ],
  templateUrl: './ag-grid-date-filter.component.html',
  styleUrl: './ag-grid-date-filter.component.scss',
})
export class AgCustomDateFilterComponent implements IFilterAngularComp {
  private params!: IFilterParams;

  dateFrom = new FormControl<Date | string | null>(null);
  dateTo = new FormControl<Date | string | null>(null);

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return !!this.dateFrom.value || !!this.dateTo.value;
  }

  getModel() {
    return this.dateFrom.value && this.dateTo.value
      ? {
          dateFrom: this.dateFrom.value,
          dateTo: this.dateTo.value,
          filterType: 'date',
          type: 'inRange',
        }
      : null;
  }

  setModel(model: { dateFrom: string; dateTo: string; filterType?: string; type?: string }): void {
    this.dateFrom.setValue(model?.dateFrom ?? null);
    this.dateTo.setValue(model?.dateTo ?? null);
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    const value = new Date(params.data);
    if (!value || isNaN(value.getTime())) return false;

    const from = this.dateFrom.value;
    const to = this.dateTo.value;

    if ((from && value < from) || (to && value > to)) return false;

    return true;
  }

  applyFilter(): void {
    this.params.filterChangedCallback();
    this.params.api?.hidePopupMenu();
  }

  resetFilter(): void {
    this.dateFrom.setValue(null);
    this.dateTo.setValue(null);
    this.params.filterChangedCallback();
  }
}
